import { render, staticRenderFns } from "./AlifOrders.vue?vue&type=template&id=6c7fd93e&"
import script from "./AlifOrders.vue?vue&type=script&lang=js&"
export * from "./AlifOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports